import React, { FC } from 'react'
import '../css/components/Spinner.scss'

interface SpinnerProps {
  size?: string
}

const Spinner: FC<SpinnerProps> = ({ size }) => {
  return <div className="spinner" style={getStyles(size)} />
}

const getStyles = (size: string = '20') => {
  return {
    width: size + 'px',
    height: size + 'px',
  }
}

export default Spinner
